import React from 'react';
import { useDispatch } from 'react-redux';
import { CModal, CModalBody, CButton, CModalFooter } from '@coreui/react-pro';
import PropTypes from 'prop-types';
import CIcon from '@coreui/icons-react';
import { cilX } from '@coreui/icons';

import { setShowEditPopup } from '../../../actions/general';

const InviteUserPopup = ({ children, btnText, className, isLoading, disabled, setStateWhenClose, onAccept }) => {
     const dispatch = useDispatch();

     const handleCancelButtonClick = () => {
          dispatch(setShowEditPopup(null));

          if (setStateWhenClose) {
               setStateWhenClose();
          }
     };

     return (
          <CModal visible={true} alignment="center" className={`invite-user-owner-popup ${className}`} onClose={handleCancelButtonClick}>
               <CModalBody>
                    <div className="invite-owner-description">
                         <CIcon icon={cilX} onClick={handleCancelButtonClick} className="icon-close-popup" />
                         {children}
                    </div>
               </CModalBody>
               <CModalFooter>
                    <CButton color="light" onClick={handleCancelButtonClick}>
                         Cancel
                    </CButton>
                    {
                         <CButton color="primary" disabled={isLoading || disabled} onClick={onAccept}>
                              {isLoading ? (
                                   <>
                                        Waiting
                                        <span className="dots-waiting" />
                                   </>
                              ) : (
                                   btnText
                              )}
                         </CButton>
                    }
               </CModalFooter>
          </CModal>
     );
};

InviteUserPopup.propTypes = {
     show: PropTypes.bool,
     isLoading: PropTypes.bool,
     onClose: PropTypes.func,
     event: PropTypes.func,
     btnText: PropTypes.string,
};

export default InviteUserPopup;
